module.exports = __webpack_public_path__ + "img/o-nas-1050x630.0ee1806c.jpg";